const URL_CONFIG = {
  LOCATION_URL: process.env.REACT_APP_API_LOCATION_URL,
  BOOKING_URL: process.env.REACT_APP_API_BOOKING_URL,
  SOCKET_URL: process.env.REACT_APP_API_SOCKET_URL,
  SESSION_TIMEOUT: 60 * 1000 * 30,
  gaTrackingID: process.env.REACT_APP_GOOGLE_TRACKING_ID,
  googleAPIKey: process.env.REACT_APP_GOOGLE_MAP_KEY,
  companyId: process.env.REACT_APP_COMPANY_ID,
  bucketUrl: process.env.REACT_APP_BUCKET_URL,
};
export default URL_CONFIG;
